
<template>
  <ol class="com-order-line">
    <component 
      v-for="child, index in dataInfo.children" 
      :key="index"
      :is="child.cpt" 
      :data-info="child.data"
      :article-info="articleInfo"
    ></component>
  </ol>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin],
}
</script>

<style lang="less">
.com-order-line {
  padding: 0 0 0 26px;
  margin: 8px 0 0;
  list-style-type: decimal;
  line-height: 1.8;
  color: #28323c;
}
</style>